import React from "react";
import MultiLineChart from "../../../../HtmlElements/MultiLineChart";

function FinancialTrends() {
  return (
    <div>
      <MultiLineChart />
    </div>
  );
}

export default FinancialTrends;
